/* ============================================================
   DIETMONSTA · Storage & heating
   Reveals timer rings and step cards as they scroll into view.
   Purely presentational — the instructions are readable with JS
   off, which for food-safety content is non-negotiable.
   ============================================================ */

class DMStorage extends HTMLElement {
  connectedCallback() {
    const targets = this.querySelectorAll('[data-dm-reveal]');
    if (!targets.length) return;

    // No IntersectionObserver, or reduced motion: show everything at once.
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (!entry.isIntersecting) return;
          // Stagger slightly so a row of steps resolves left to right.
          setTimeout(() => entry.target.classList.add('is-in'), i * 90);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );
    targets.forEach((el) => io.observe(el));
  }
}

if (!customElements.get('dm-storage')) customElements.define('dm-storage', DMStorage);
